/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Wrapper for localStorage
 */
class LocalStorageUtils {
	// Calls getItem
	getItem(key: string) {
		return LocalStorageUtils._getItem(key);
	}

	// Calls setItem
	setItem(key: string, data: any) {
		LocalStorageUtils._setItem(key, data);
	}

	// Calls removeItem
	removeItem(key: string) {
		LocalStorageUtils._removeItem(key);
	}

	// Executes the setItem
	static _setItem(key: string, value: any) {
		if (window.cchome.util.storageAvailable('localStorage')) {
			try {
				// We JSON.stringify for you so that you don't have to
				window.localStorage.setItem(key, JSON.stringify(value));
			} catch (e) {
				window.cchome.util.logger.error('Local Storage Utils', 'Error writing to Local Storage', e.toString());
			}
		}
	}

	// Executes the getItem
	static _getItem(key: string) {
		if (window.cchome.util.storageAvailable('localStorage')) {
			try {
				let localStorageItem = window.localStorage.getItem(key);
				// We JSON.parse it for you so that you don't have to
				if (localStorageItem) {
					localStorageItem = JSON.parse(localStorageItem);
					return localStorageItem;
				}
				return null;
			} catch (e) {
				window.cchome.util.logger.error(
					'Local Storage Utils',
					'Error reading from Local Storage',
					e.toString(),
				);
				return new Error('Error reading from Local Storage');
			}
		} else {
			return new Error('Local Storage Unavailable');
		}
	}

	// Executes the removeItem
	static _removeItem(key: string) {
		if (window.cchome.util.storageAvailable('localStorage')) {
			try {
				window.localStorage.removeItem(key);
			} catch (e) {
				window.cchome.util.logger.error(
					'Local Storage Utils',
					'Error removing from Local Storage',
					e.toString(),
				);
			}
		}
	}
}

export default LocalStorageUtils;
